import { render, staticRenderFns } from "./FinanceIncome.vue?vue&type=template&id=2b0450a7"
import script from "./FinanceIncome.vue?vue&type=script&lang=js"
export * from "./FinanceIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports